import { orientationModuleHeaderService } from '@/services/api/orientationModuleHeader.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { orientationModuleHeaderModel } from '@/models/api/orientationModuleHeader.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const ORIENTATION_MODULE_HEADER_MODULE = "api/orientationModuleHeader";

// ACTIONS
export const GET_ALL_ORIENTATION_MODULE_HEADER = 'getAllOrientationModuleHeader';
export const CREATE_ORIENTATION_MODULE_HEADER = 'createOrientationModuleHeader';
export const GET_ORIENTATION_MODULE_HEADER = 'getOrientationModuleHeader';
export const UPDATE_ORIENTATION_MODULE_HEADER = 'updateOrientationModuleHeader';
export const UPDATE_ORIENTATION_MODULE_HEADER_STATUS = 'updateOrientationModuleHeaderStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_ORIENTATION_MODULE_HEADER_SUCCESS = "allOrientationModuleHeaderSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_ORIENTATION_MODULE_HEADER_SUCCESS = "getOrientationModuleHeaderSuccess";

export const actions = {
    [GET_ALL_ORIENTATION_MODULE_HEADER]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return orientationModuleHeaderService
            .getAll(filter)
            .then((result) => {
                commit(ALL_ORIENTATION_MODULE_HEADER_SUCCESS, {data: result});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_ORIENTATION_MODULE_HEADER]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return orientationModuleHeaderService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_ORIENTATION_MODULE_HEADER, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_ORIENTATION_MODULE_HEADER]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return orientationModuleHeaderService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_ORIENTATION_MODULE_HEADER_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_ORIENTATION_MODULE_HEADER]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return orientationModuleHeaderService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_ORIENTATION_MODULE_HEADER, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_ORIENTATION_MODULE_HEADER_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return orientationModuleHeaderService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_ORIENTATION_MODULE_HEADER, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_ORIENTATION_MODULE_HEADER_SUCCESS](state, {data}) {
        let orientationModuleHeaderList = data.data || [];
        state.list.data = orientationModuleHeaderList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = orientationModuleHeaderList.map(item => orientationModuleHeaderModel(item));
        }
    },
    [GET_ORIENTATION_MODULE_HEADER_SUCCESS](state, data) {
        state.details = orientationModuleHeaderModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
